import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useState} from 'react'
import {Dialog, Input, InputAdornment, OutlinedInput, Slide, SlideProps} from "@mui/material";
import {AxiosError} from "axios";
import {useQuery} from "@tanstack/react-query";
import DialogHeader from "@/view/layout/DialogHeader";
import HeaderSpacer from "@/view/layout/HeaderSpacer";
import BottomButton from "@/view/common/component/button/BottomButton";
import BoardService, {BoardData, BoardItem} from "@/service/BoardService";
import {USER_ID} from "@/common/Constant";
import StringUtil from "@/common/StringUtil";
import StorageUtil from "@/common/StorageUtil";
import {history} from "@/view/common/component/History";
import Confirm from "@/view/common/popup/Confirm";
import BoardAddComplete from "@/view/board/BoardAddComplete";
import boardService from "@/service/BoardService";

export interface BoardAddParam {
    board: BoardData | undefined
}

const BoardEdit = forwardRef((props: BoardAddParam, ref) => {
    const titleMaxLength = 20
    const contentMaxLength = 1000
    const [titleLength, setTitleLength] = useState(props.board? props.board.title.length: 0)
    const [contentLength, setContentLengh] = useState(props.board? props.board.content.length: 0)
    const [boardItem, setBoardItem] = useState({ title: props.board? props.board.title: '' ,content: props.board? props.board.content: ''})

    const inputChanged = (event: { target: { id: string; value: string; }; }) => {
        const { id, value } = event.target
        setBoardItem({ ...boardItem, [id]: value })
        if(id === 'title' && value !== undefined){
            setTitleLength(value.length)

        }else if(id === 'content' && value !== undefined){
            setContentLengh(value.length)
        }
    }

    useImperativeHandle(ref, () => ({
        update: () =>{
            return updateBoard()
        }
    }))

    const updateBoard = () =>{
        const updateItem = {
            title: boardItem.title,
            content: boardItem.content,
            writerId: localStorage.getItem(USER_ID) as unknown as number
        }
        boardService.updateBoard(updateItem, props.board? props.board.boardNo: 0)
            .then(r =>r)
            .catch(reason => console.log(reason))
    }

    return <>
            <Input className={'b2_r w-100p h-22px mt-39px mb-24px'}
                   id={'title'}
                   required={true}
                   placeholder={'제목을 입력해주세요'}
                   value={boardItem.title}
                   inputProps={{ maxLength: titleMaxLength}}
                   endAdornment={<InputAdornment className={'c1_r'} position="end">{titleLength}/{titleMaxLength}</InputAdornment>}
                   onChange={inputChanged}
            />
            <OutlinedInput className={'b2_r w-100p'}
                           style={{flexDirection: 'column', alignItems : 'flex-end'}}
                           id={'content'}
                           required={true}
                           placeholder={'내용을 입력해주세요'}
                           value={boardItem.content}
                           rows={10}
                           multiline={true}
                           inputProps={{ maxLength: contentMaxLength}}
                           endAdornment={<InputAdornment className={'c1_r'} position="end">{contentLength}/{contentMaxLength}</InputAdornment>}
                           onChange={inputChanged}
            />
    </>
})

export default BoardEdit
